// EditPost.js
import React, { useState } from "react";

const EditPost = ({ post, onSave, onCancel }) => {
  const [editText, setEditText] = useState(post.body);

  const handleSave = () => {
    onSave(post, editText);
  };

  return (
    <div>
      <input
        value={editText}
        onChange={(e) => setEditText(e.target.value)}
        className="w-full p-2 border rounded-md mb-2"
      />
      <button
        onClick={handleSave}
        className="px-4 py-2 mr-2 bg-green-500 text-white rounded-md hover:bg-green-700"
      >
        Save
      </button>
      <button
        onClick={onCancel}
        className="px-4 py-2 bg-gray-400 text-white rounded-md hover:bg-gray-600"
      >
        Cancel
      </button>
    </div>
  );
};

export default EditPost;
